import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {useContext} from 'react';

import {MainFilterContext} from '../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../provider/main-filter/main-filter-type';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';

import {fetchAutoAbusesCount} from './auto-abuses-count-api';
import {ComplaintsCountType} from './auto-abuses-count-type';

export function useAutoAbusesCount(filter: ReviewsAndAnswersFilterStateType): UseQueryResult<ComplaintsCountType> {
    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    return useQuery({
        queryKey: ['autoAbusesCount', filter, mainFilterKey],
        queryFn: async () => {
            return fetchAutoAbusesCount(filter, mainFilterKey);
        },
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}
